<template>
  <div>
    <Subheader id="events-title" title="Events" />

    <div class="app-content-column">
      <div v-if="!dataLoaded" class="container">Loading...</div>
      <div v-if="dataLoaded">
        <div v-if="events.length === 0">
          <span>No Events Found</span>
        </div>

        <div v-for="event in events" :key="event.id" class="card-custom centered-block">
          <router-link :to="{ name: 'EventDetails', params: { eventId: event.id } }">
            <div class="photo-container">
              <img :src="event.photo" :alt="event.title + ' photo'" />
            </div>
          </router-link>

          <div class="card-content-container">
            <h5>{{ event.title }}</h5>
            <p>{{ event.date | eventDate }}</p>
            <p>{{ event.shortDescription }}</p>
            <div class="is-centered">
              <router-link :to="{ name: 'EventDetails', params: { eventId: event.id } }">
                <button class="small-button">Learn More</button>
              </router-link>
            </div>
          </div>
        </div>

        <Pagination
          :pagination-details="paginationDetails"
          :show-only-result-count="false"
          :hide-pages="true"
          @update="refreshData($event)"
        />
      </div>
      <div v-if="dataLoaded && events.length > 1">
        <div class="scroll-button" @click="scrollToTop">Return to Top</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

import { getPaginationDataFromResponse } from '@/services/utils/pagination'
import Event from '@/services/events'

import Subheader from '@/components/Subheader'
import Pagination from '@/components/Pagination'

export default {
  name: 'ListEvents',
  components: {
    Subheader,
    Pagination,
  },
  filters: {
    eventDate: function(date) {
      return moment(date).format('DD.MM.YYYY HH:MM')
    },
  },
  data() {
    return {
      paginationDetails: {},
      events: [],
      dataLoaded: false,
    }
  },
  created() {
    this.refreshData()
  },
  methods: {
    scrollToTop() {
      let element = document.getElementById('events-title')
      element.scrollIntoView({ behavior: 'smooth' })
    },
    refreshData(page = null) {
      this.dataLoaded = false

      let eventPromise = Event.api.list({ filters: { page } }).then(data => {
        this.paginationDetails = getPaginationDataFromResponse(data)
        this.events = data.results
      })

      Promise.all([eventPromise])
        .then(() => {
          this.dataLoaded = true
        })
        .catch(() => (this.dataLoaded = true))
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/layout';
@import '../styles/forms';
@import '../styles/mixins/buttons';

.card-custom {
  margin: 1.25rem;

  background-color: #ffffff;
  border-radius: 0.25rem;
  box-shadow: 0 20px 20px 0 rgba(0, 0, 0, 0.08);
  overflow: hidden;

  .photo-container {
    height: 244px;
    width: 100%;

    display: flex;
    justify-content: center;
    align-items: center;

    overflow: hidden;

    img {
      display: block;
      width: 100%;
      min-height: 100%;
      object-fit: cover;
      background-color: rgba($primary, 0.7);
    }
  }

  .card-content-container {
    padding: 1.5rem;
  }
}

.centered-block {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}

.scroll-button {
  position: fixed;
  bottom: 20px;
  right: 30px;
  z-index: 99;
  font-size: 18px;
  border: none;
  outline: none;
  background-color: $secondary;
  color: white;
  cursor: pointer;
  padding: 15px;
  border-radius: 4px;
}
</style>
